import { Row, Col } from "react-bootstrap"
import React, { useState } from "react"
import { CourseHeaderButton } from "./course_header_button"
import { useSelector } from "react-redux"
import { ImportCourseModal } from "./import_course_modal"
import { CopyCourseModal } from "./copy_course_modal"
import { ComplianceCheckModal } from "./compliance_check_modal"

export const CourseButtonsRow = () => {

  const addCourseUrl = useSelector((state) => state?.misc?.data?.routes?.addCourseUrl)
  const checkComplianceModalData = useSelector((state) => state?.misc?.data?.complianceCheckModalData)
  // const [showImportModal, setShowImportModal] = useState(false)
  const [showCopyModal, setShowCopyModal] = useState(false)
  const [showComplianceCheckModal, setShowComplianceCheckModal] = useState(checkComplianceModalData?.show)

  return(
    <div className="button-row">
      <div className="left-buttons-container">
        <CourseHeaderButton url={addCourseUrl} text={window.I18n.t('courses.copy_course_modal.add_a_course')}/>
        {/* <CourseHeaderButton onClick={() => setShowImportModal(true)} text={window.I18n.t('courses.bootstrap_courses.import_from_usga')}/> */}
      </div>
      <CourseHeaderButton onClick={() => setShowCopyModal(true)} extraStyling='pull-right' text={window.I18n.t('courses.copy_course_modal.copy_in_admin')}/>
      {/* {showImportModal && <ImportCourseModal show={showImportModal} setShow={setShowImportModal}/>} */}
      {showCopyModal && <CopyCourseModal show={showCopyModal} setShow={(setShowCopyModal)}/>}
      {showComplianceCheckModal && <ComplianceCheckModal show={showComplianceCheckModal} setShow={setShowComplianceCheckModal} modalData={checkComplianceModalData} />}
    </div>
  )
}